import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PRODUCTS, REVIEWS, VIDEOS, COMPANY } from '../data/content.js'

export default function Home() {
  const { t } = useTranslation()
  const values = t('mission.values', { returnObjects: true })
  const stats = t('stats.items', { returnObjects: true })

  return (
    <div className="home">
      {/* HERO */}
      <section className="hero">
        <div className="hero-grid" aria-hidden="true">
          <svg className="h-full w-full">
            <defs>
              <pattern id="hero-grid" width="48" height="48" patternUnits="userSpaceOnUse">
                <path d="M 48 0 L 0 0 0 48" fill="none" stroke="#64748b" strokeWidth="0.6" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#hero-grid)" />
          </svg>
        </div>
        <div className="hero-glow" aria-hidden="true" />
        <div className="container hero-inner">
          <p className="eyebrow">{t('hero.eyebrow')}</p>
          <h1>Almus</h1>
          <p className="hero-slogan">{t('hero.title')}</p>
          <p className="hero-text">{t('hero.text')}</p>
          <div className="hero-cta">
            <Link to="/contact" className="btn btn-primary">{t('hero.cta')}</Link>
            <Link to="/assortiment" className="btn btn-ghost">{t('products.title')} ↓</Link>
          </div>
        </div>
      </section>

      {/* МИССИЯ */}
      <section className="section section-bordered">
        <div className="container">
          <p className="eyebrow">{t('mission.title')}</p>
          <h2 className="section-title">{t('mission.text')}</h2>
          <p className="eyebrow-label" style={{ display: 'block', marginTop: 32 }}>{t('mission.valuesTitle')}</p>
          <div className="grid-4">
            {values.map((v) => (
              <div key={v} className="card">
                <h3>{v}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ТИІМДІЛІК / ЭФФЕКТИВНОСТЬ */}
      <section className="section section-bordered">
        <div className="container">
          <p className="eyebrow">{t('stats.eyebrow')}</p>
          <h2 className="section-title">{t('stats.title')}</h2>
          <p className="section-sub">{t('stats.subtitle')}</p>
          <div className="grid-4">
            {stats.map((s) => (
              <div key={s.title} className="card">
                <div className="stat-value">{s.value}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ӨНІМДЕР */}
      <section className="section section-bordered">
        <div className="container">
          <p className="eyebrow">Almus</p>
          <h2 className="section-title">{t('products.title')}</h2>
          <div className="grid-3">
            {PRODUCTS.map((product) => {
              const info = t(`productItems.${product.id}`, { returnObjects: true })
              return (
                <Link key={product.id} to={`/assortiment/${product.slug}`} className="card">
                  <h3>{info.title}</h3>
                  <p>{info.desc.length > 140 ? `${info.desc.slice(0, 140)}…` : info.desc}</p>
                  <span className="card-link">{t('products.learnMore')} →</span>
                </Link>
              )
            })}
          </div>
        </div>
      </section>

      {/* ӨНДІРІС ВИДЕОЛАРЫ */}
      <section className="section section-bordered">
        <div className="container">
          <p className="eyebrow">{t('videos.eyebrow')}</p>
          <h2 className="section-title">{t('videos.title')}</h2>
          <p className="section-sub">{t('videos.subtitle')}</p>
          <div className="video-grid">
            {VIDEOS.map((video) => (
              <figure key={video.id} className="video-frame" style={{ margin: 0 }}>
                <video
                  controls
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  poster={video.poster}
                  src={video.src}
                />
                <figcaption className="video-caption">{t(video.captionKey)}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* ПІКІРЛЕР */}
      <section className="section section-bordered">
        <div className="container">
          <h2 className="section-title">{t('reviews.title')}</h2>
          <div className="grid-2">
            {REVIEWS.map((review) => (
              <blockquote key={review.id} className="review-card">
                <p>«{t(review.textKey)}»</p>
                <cite>{t(review.nameKey)}, {t(review.roleKey)}</cite>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-band">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="section-title" style={{ maxWidth: 'none' }}>{t('hero.title')}</h2>
          <div className="hero-cta" style={{ marginTop: 28 }}>
            <Link to="/contact" className="btn btn-primary">{t('hero.cta')}</Link>
            <a href={`https://wa.me/${COMPANY.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
              WhatsApp: {COMPANY.whatsapp}
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}